import React from "react";
import "../../styles/audiobook/RecordingCountdown.scss";
import { Player } from "@lottiefiles/react-lottie-player";
import useAppTranslation from "../../hooks/useAppTranslation";

const RecordingCountdown = ({ onDone, onClose, selectedMode }) => {
  const { t, language } = useAppTranslation("components/audiobook/recordingCountdown");
  const isRussian = language === "ru";

  const stepKey =
    selectedMode === "voice" ? "steps.myAudiobook" : "steps.customAudiobook";
  const descKey =
    selectedMode === "voice" ? "descriptions.voice" : "descriptions.custom";

  return (
    <>
      <div className={`audio-explain-container recording ${isRussian ? "ru-text-center" : ""}`}>
        <figure className="close-select-mode" onClick={onClose}>
          <img
            src={"/images/audiobook/guide-text-close.svg"}
            alt={t("actions.close")}
          />
        </figure>
        <p className="step-text">{t(stepKey)}</p>
        <h3>{t("title")}</h3>
        <p className="recording-desc">{t(descKey)}</p>
        <button type="button" className="recording-confirm-btn" onClick={onDone}>
          <span>{t("actions.create")}</span>
        </button>
      </div>
      <Player
        src={"/lottie/nikki-recording.json"}
        className="recording-character"
        autoplay
        loop
      />
    </>
  );
};

export default RecordingCountdown;
